<template>
  <div>
    <!-- Toggle tabs -->
    <div class="maint-tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        class="maint-tab"
        :class="{ 'maint-tab--active': activeTab === tab.key }"
        @click="activeTab = tab.key"
      >
        <i :class="tab.icon"></i>
        {{ tab.label }}
        <span class="maint-tab__badge">{{ tab.total }}</span>
      </button>
    </div>

    <!-- Chart -->
    <apexchart
      type="bar"
      height="260"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
const STATUS_COLORS = {
  new:              '#8a9484',
  under_review:     '#a69057',
  assigned:         '#6f8a5a',
  arrived:          '#4f6a3e',
  done:             '#3e572e',
  hold:             '#c5b47f',
  waiting_deposit:  '#d7a658',
  deposit_issue:    '#d9822b',
  waiting_payment:  '#8d7948',
  payment_issue:    '#c56e2d',
  client_canceled:  '#c77462',
  provier_canceled: '#b85c4a',
};

export default {
  name: 'MaintenanceChart',

  props: {
    maintenanceStats: { type: Object, default: () => ({}) },
    photoStats:       { type: Object, default: () => ({}) },
    statusChoices:    { type: Object, default: () => ({}) },
  },

  data() {
    return { activeTab: 'maintenance' };
  },

  computed: {
    tabs() {
      return [
        {
          key:   'maintenance',
          label: 'طلبات الصيانة',
          icon:  'bi bi-tools',
          total: Object.values(this.maintenanceStats).reduce((a, b) => a + (parseInt(b) || 0), 0),
        },
        {
          key:   'photos',
          label: 'طلبات التصوير',
          icon:  'bi bi-camera-fill',
          total: Object.values(this.photoStats).reduce((a, b) => a + (parseInt(b) || 0), 0),
        },
      ];
    },

    activeStats() {
      return this.activeTab === 'maintenance'
        ? this.maintenanceStats
        : this.photoStats;
    },

    activeKeys() {
      return Object.keys(this.activeStats).filter(k => this.activeStats[k] != null);
    },

    series() {
      return [{
        name: this.activeTab === 'maintenance' ? 'طلبات الصيانة' : 'طلبات التصوير',
        data: this.activeKeys.map(k => parseInt(this.activeStats[k]) || 0),
      }];
    },

    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
          fontFamily: 'inherit',
          animations: { enabled: true, speed: 400 },
        },
        colors: this.activeKeys.map(k => STATUS_COLORS[k] || '#8a9484'),
        plotOptions: {
          bar: {
            borderRadius: 5,
            distributed: true,
            columnWidth: '55%',
          },
        },
        dataLabels: { enabled: true, style: { fontSize: '11px' } },
        legend: { show: false },
        xaxis: {
          categories: this.activeKeys.map(k => this.statusChoices[k] || k),
          labels: {
            style: { fontSize: '11px', colors: '#6f776b' },
            rotate: -30,
          },
        },
        yaxis: {
          labels: {
            style: { colors: '#8a9286', fontSize: '11px' },
            formatter: v => Math.round(v),
          },
        },
        grid: { borderColor: '#edf1e9', strokeDashArray: 4 },
        tooltip: {
          y: { formatter: v => v + ' طلب' },
        },
      };
    },
  },
};
</script>

<style scoped>
.maint-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}
.maint-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid #dce4d6;
  background: #f5f8f1;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  transition: all .15s;
  font-family: inherit;
}
.maint-tab:hover { border-color: #a69057; background: #fff; }
.maint-tab--active {
  background: #3e572e;
  color: #fff;
  border-color: #3e572e;
}
.maint-tab--active .maint-tab__badge {
  background: rgba(255,255,255,.25);
  color: #fff;
}
.maint-tab__badge {
  background: #ebf4df;
  color: #3e572e;
  border-radius: 20px;
  padding: 1px 7px;
  font-size: 11px;
  font-weight: 600;
  min-width: 22px;
  text-align: center;
}
</style>
